import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { IJharokhaTokenRes } from '.';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '../profile';

interface IJharokhaToken {
	mutate: UseMutateFunction<IJharokhaTokenRes | null, Error, void, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useMutateJharokhaToken = (): IJharokhaToken => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	const fetchJharokhaToken = async (): Promise<IJharokhaTokenRes | null> => {
		if (profile[0]?.phone_number_c) {
			return await APIService.getData<IJharokhaTokenRes>(APICONFIG.GET_JHAROKHA_TOKEN, {
				phone: profile[0]?.phone_number_c,
			});
		}
		return null;
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: fetchJharokhaToken,
	});

	return {
		mutate,
		isPending,
		isError,
		error,
	};
};
